import React from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { CategoriesList } from './components/CategoriesList'

const CategoriesPage: React.FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Categories</PageTitle>
      <div className='d-flex flex-column flex-lg-row'>
        <div className='flex-lg-row-fluid'>
          <CategoriesList />
        </div>
      </div>
    </>
  )
}

export { CategoriesPage }
